import styled from "styled-components";

export const Title = styled.h1``;

export const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Button = styled.button``;
